import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { allergenService } from '../services/allergen.service';

export const fetchAllergens = createAsyncThunk(
  'allergen/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      return await allergenService.getAllAllergens();
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const createAllergen = createAsyncThunk(
  'allergen/create',
  async (payload, { rejectWithValue }) => {
    try {
      return await allergenService.createAllergen(payload);
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updateAllergen = createAsyncThunk(
  'allergen/update',
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      return await allergenService.updateAllergen(id, payload);
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const deleteAllergen = createAsyncThunk(
  'allergen/delete',
  async (id, { rejectWithValue }) => {
    try {
      return await allergenService.deleteAllergen(id);
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const allergenSlice = createSlice({
  name: 'allergen',
  initialState: {
    allergens: [],
    loading: false,
    actionStatus: 'idle',
    error: null,
  },
  reducers: {
    resetActionStatus: (state) => {
      state.actionStatus = 'idle';
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllergens.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllergens.fulfilled, (state, action) => {
        state.loading = false;
        state.allergens = action.payload;
      })
      .addCase(fetchAllergens.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createAllergen.fulfilled, (state) => {
        state.actionStatus = 'succeeded';
      })
      .addCase(createAllergen.rejected, (state, action) => {
        state.actionStatus = 'failed';
        state.error = action.payload;
      })
      .addCase(updateAllergen.fulfilled, (state) => {
        state.actionStatus = 'succeeded';
      })
      .addCase(updateAllergen.rejected, (state, action) => {
        state.actionStatus = 'failed';
        state.error = action.payload;
      })
      .addCase(deleteAllergen.fulfilled, (state, action) => {
        state.allergens = state.allergens.filter(
          (a) => a.allergenId !== action.payload
        );
      });
  },
});

export const { resetActionStatus } = allergenSlice.actions;
export default allergenSlice.reducer;